<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Info', route: '/backoffice/info' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Elenco info</h2>
    </div>

    <p-table #dt
        [loading]="loading"
        [value]="infos"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['titoli']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} info"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50]"
        (onRowReorder)="onReorder($event)">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full items-stretch">
                <input type="text" pInputText class="flex-1" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca info…" />
                <div class="table-toolbar-btns">
                    <a class="acc-btn acc-btn-primary" routerLink="/backoffice/info/add">
                        <i class="bi bi-plus"></i>
                        Aggiungi info
                    </a>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th class="w-1/12"></th>
                <th pSortableColumn="titoli" class="w-10/12">Titolo/i <span class="inline-flex"><p-sortIcon field="titoli" /></span></th>
                <th class="w-2/12 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-info let-index="rowIndex">
            <tr [pReorderableRow]="index">
                <td class="text-center">
                    <i class="bi bi-list text-2xl hover:text-black cursor-grab" pReorderableRowHandle></i>
                </td>
                <td>
                    <span class="p-column-title">Titolo/i</span>
                    <span class="cell-nome">{{info.titoli}}</span>
                </td>
                <td class="text-center">
                    <span class="p-column-title">Azioni</span>
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/info/' + info.id" pTooltip="Modifica" tooltipPosition="bottom"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteInfo>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteInfo()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteInfo()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteInfo($event, info)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessuna info trovata.</td>
            </tr>
        </ng-template>
    </p-table>
</section>
